// extracted by mini-css-extract-plugin
export var copyableField = "_qr-4";
export var customerBadge = "_qr-0";
export var customerInfoTitle = "_qr-2";
export var details = "_qr-1";
export var dropdownContainer = "_qr-5";
export var dropdownImage = "_qr-6";
export var editAssigneeForm = "_qr-a";
export var editButton = "_qr-3";
export var email = "_qr-7";
export var hidden = "_qr-d";
export var input = "_qr-8";
export var saveButton = "_qr-b";
export var shopifyIcon = "_qr-c";
export var suggestionBadge = "_qr-e";
export var suggestionText = "_qr-f";
export var username = "_qr-9";